"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComboOption_1 = require("./ComboOption");
exports.default = ComboOption_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ComboBox/components/ComboOption/index.js
// module id = 1122
// module chunks = 8